export default __webpack_public_path__ + "static/media/webGL.9195fea5.png";